import { Field } from 'formik';
import {  FormControl, Grid, GridItem,Box } from '@chakra-ui/react';
import ElementInstructions from './components/ElementInstructions';
import ElementHeading from './components/ElementHeading';
import ElementErrorMessage from './components/ElementErrorMessage';
import InputWrapper from './components/InputWrapper';
import { fileUploadChange } from './utils';

const RSFileUpload = ({ fieldName, qObj, jobSeekerData, handlers, props, index }) => {

  return (
    <Box >
      <Field name={fieldName}>
        {({ field, form }) => (
          <FormControl
            isInvalid={form.errors[fieldName] && form.touched[fieldName]}
          >
            <Grid >
              <GridItem>
                <ElementHeading qObj={qObj} props={props} />
              </GridItem>
            </Grid>
            <ElementInstructions  instructions={qObj.instructions} />
            <Box sx={{height:'1rem'}}></Box>
            <InputWrapper>
              <Box sx={{
                color: 'white',
                padding: '.5rem 1rem',
                backgroundColor: '#8497E7',
                borderColor: 'black',
                borderWidth: '1px',
                borderRadius: '5px',
                width: 'fit-content',
                cursor: 'pointer',
              }}>
                <input id={field.name} name={field.name} type="file"
                       onChange={(e) => fileUploadChange(e,form,field)}
                />
              </Box>
            </InputWrapper>
            <ElementErrorMessage form={form} index={qObj.index} qid={qObj.qid} />
          </FormControl>
        )}
      </Field>
    </Box>
  );
};

export default RSFileUpload;